import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'actions/modal';
import { useAcLedMappingPost } from 'actions/ac-led-mapping';
import { ACTIONS as notificationActions } from 'actions/notification';
import { get as getConfig } from 'actions/configs';
import { MAPPING_REJECTION_REASONS_KEY } from 'constants/auto-mapping';
import { store } from 'redux-rest-reducer';
import { AC_LED_MAPPING_EVENTS } from 'constants/ac-led-mapping';
const useNotGoodMatchLogic = ({
  prospectId,
  otherTeachers,
  showOtherTeachers,
  setShowOtherTeachers,
}) => {
  const [reason, setReason] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const dispatch = useDispatch();
  const configsStore = useSelector(({ configs }) => configs);

  useEffect(() => {
    dispatch(getConfig?.(MAPPING_REJECTION_REASONS_KEY));
  }, [dispatch]);
  const options = store.get(configsStore, MAPPING_REJECTION_REASONS_KEY)?.data ?? [];
  const otherTeachersExist = otherTeachers?.length > 0;

  const onMappingFeedbackComplete = errorMessage => {
    if (errorMessage) {
      dispatch({
        type: notificationActions.SHOW_NOTIFICATION,
        payload: {
          text: 'Something went wrong.',
          duration: 10,
          showCloseIcon: true,
        },
      });
    } else {
      if (otherTeachersExist && !showOtherTeachers) {
        setSubmitSuccess(true);
        setShowOtherTeachers(true);
      } else {
        dispatch(closeModal?.());
      }
    }
  };

  const { post: mappingResultFeedbackPost, isProcessing } = useAcLedMappingPost({
    onComplete: onMappingFeedbackComplete,
  });

  const handleSubmit = prospectId => {
    const data = {
      prospect_id: prospectId,
      event_name: AC_LED_MAPPING_EVENTS.REJECT_RECOMMENDED_TEACHERS_REASON_FILL,
      event_payload: {
        reason,
      },
    };
    mappingResultFeedbackPost?.(data);
  };

  return {
    reason,
    setReason,
    handleSubmit,
    isBusy: isProcessing,
    options,
    submitSuccess,
  };
};

export default useNotGoodMatchLogic;
